import {
  COMMON_CONSTANTS,
  CustomModal,
  getTranslatedText,
  MilestoneConstraints,
  preFormatForm,
  toast,
  validateForm
} from '@nile/components';
import { TicketClient } from '@nile/graphql';
import { MilestoneForm } from '@nile/projects/src/Components/Forms';
import { CREATE_MILESTONE, GET_PROJECT } from '@nile/projects/src/Graphql';
import { ButtonGroup, Page, Button } from '@superops/ui-design-system';
import ProjectContext from '@nile/projects/src/Contexts/ProjectContext';
import { cloneDeep } from 'lodash';
import React, { useContext, useState } from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { useCheckIsItProduct } from '@nile/components/src/Utils/helpers';

const MilestoneModalWrapper = styled.div`
  min-width: 60vw;
  max-width: 1200px;
  width: 100%;
`;

const MilestoneModal = (props) => {
  const { intl } = props;
  const [newMilestone, setNewMilestone] = useState({});
  const [errors, setErrors] = useState(null);
  const isItProduct = useCheckIsItProduct();

  const projectContext = useContext(ProjectContext);

  const handleUpdate = (newObj) => {
    setNewMilestone(newObj);
  };

  const createMilestoneHandler = () => {
    const dummyForm = cloneDeep(newMilestone);
    const validationResult = validateForm(
      preFormatForm(dummyForm),
      MilestoneConstraints
    );
    if (validationResult) {
      setErrors(validationResult);
      return;
    }
    setErrors(null);
    const milestoneOrder = (projectContext.project.milestones?.length ?? 0) + 1;
    TicketClient.mutate({
      mutation: CREATE_MILESTONE,
      variables: {
        projectId: props.projectId,
        input: {
          ...newMilestone,
          milestoneOrder
        }
      }
    })
      .then((res) => {
        if (res?.data?.createMilestone) {
          toast('success', 'Milestone created successfully');
          props.handleUpdate('addMilestone', {
            ...res.data.createMilestone,
            milestoneOrder
          });
          // We need to update project  when the milestone is created
          // This is done as the members of the projects will be from the projects
          TicketClient.query({
            query: GET_PROJECT,
            variables: { projectId: props.projectId, isItProduct },
            fetchPolicy: COMMON_CONSTANTS.CACHE_POLICIES.NETWORK_ONLY
          }).then((resp) => {
            if (resp?.data?.getProject) {
              if (props?.setProject) {
                props.setProject(resp.data.getProject);
                setSheetActive(!sheetActive);
              }
            }
          });
          props.handleChange();
        }
      })
      .catch((err) => {
        // if (err?.graphQLErrors?.[0]?.extensions?.clientError?.[0]?.errorCode) {
        //   toast(
        //     'error',
        //     <FormattedMessage
        //       id={
        //         ERROR_CODES[
        //           err.graphQLErrors[0].extensions.clientError[0].errorCode
        //         ]
        //       }
        //     />
        //   );
        // } else {
        //   // toast('error', 'Something went wrong');
        // }
      });
  };

  return (
    <>
      <CustomModal
        large
        activator={props.reference.current}
        open={props.active}
        onClose={props.handleChange}
        title={getTranslatedText(intl, 'project.details.milestone.add')}
        primaryAction={{
          content: getTranslatedText(intl, 'project.details.milestone.add'),
          onAction: createMilestoneHandler
        }}
        secondaryActions={[
          {
            content: getTranslatedText(intl, 'common.cancel'),
            onAction: props.handleChange
          }
        ]}
        zIndex={516}
      >
        <MilestoneModalWrapper>
          <Page
            title={getTranslatedText(intl, 'project.details.milestone.add')}
            primaryAction={
              <ButtonGroup>
                <Button plainSecondary onClick={props.handleChange}>
                  <FormattedMessage id="common.cancel" />
                </Button>

                <Button primary onClick={createMilestoneHandler}>
                  <FormattedMessage id="project.details.milestone.add" />
                </Button>
              </ButtonGroup>
            }
            variant="primary"
          >
            <MilestoneForm
              milestone={newMilestone}
              handleUpdate={handleUpdate}
              errors={errors}
              taskTemplates={props?.taskTemplates}
              projectId={props?.projectId}
            />
          </Page>
        </MilestoneModalWrapper>
      </CustomModal>
    </>
  );
};

export default injectIntl(MilestoneModal);
